import { render } from "./radio-tutorial.vue?vue&type=template&id=6a5ddcf4"
import script from "./radio-tutorial.vue?vue&type=script&lang=js"
export * from "./radio-tutorial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__